import React from 'react'
import { Empty } from 'antd'

import type { LntEmptyProps } from './types'

export const LntEmpty: React.FC<LntEmptyProps> = props => {
  return <Empty { ...props } />
}
